import { TRIM_TOOL } from '@constants/trim-tool';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { GuideCardItem } from 'src/types/landing-page';
import Guide from './Guide';

interface GuideCards {
  guideCards: GuideCardItem[];
  platform: PlatformType;
  browser: BrowserType;
}

const Guides = (props: GuideCards) => {
  const { cards } = TRIM_TOOL.GUIDE;
  const { guideCards, platform, browser } = props;

  return (
    <div
      className={ivclass(
        'iv-grid',
        'iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12',
        'sm:iv-gap-20 md:iv-gap-[27px] lg:iv-gap-40 xl:iv-gap-40',
      )}
    >
      {guideCards.map((card, idx) => {
        const { bgImage } = cards[idx];
        const { heading1, heading2, description, cardImage } = card;

        return (
          <div key={idx} className={ivclass('iv-col-span-4 md:iv-col-span-8')}>
            <Guide
              no={idx + 1}
              heading1={heading1}
              heading2={heading2}
              description={description}
              cardImage={cardImage}
              bgImage={bgImage}
              platform={platform}
              browser={browser}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Guides;
